import * as React from "react";
import { NumericFormat } from "react-number-format";
import { convertToNumber } from "../../../../utils/storage";

interface QuantitySectionProps {
  isPlants: boolean;
  isIphone: boolean;
  count: string;
  onChangeCount: (next: string) => void;
  pcsPerUnit: number | null;
  formatQuantityData: (amount: number) => string;
}

const QuantitySection = ({
  isPlants,
  isIphone,
  count,
  onChangeCount,
  pcsPerUnit,
  formatQuantityData,
}: QuantitySectionProps) => {
  const pcsTotal =
    !isPlants && pcsPerUnit !== null
      ? formatQuantityData(convertToNumber(count) * pcsPerUnit)
      : null;

  return (
    <div className="quantity-detail">
      <div className="title-quantity">
        <span className=" title">Quantity </span>

        <span className="title descript">
          {!isPlants && pcsPerUnit !== null
            ? `${formatQuantityData(pcsPerUnit)} pcs per pallet`
            : ""}
        </span>
      </div>

      <div className="quantity-right">
        <div className="psc">
          <div className="qty-col">
            <NumericFormat
              style={{
                textAlign: "center",
                fontSize: isIphone ? 15 : 16,
                outline: "none",
                borderColor: "#878787",
                paddingLeft: -5,
                paddingRight: -5,
              }}
              value={count}
              allowNegative={false}
              onChange={(e) => onChangeCount(e.target.value)}
              thousandSeparator=","
            />

            {pcsTotal !== null && <div className="pcs-total">{pcsTotal} pcs</div>}
          </div>

          <span className="qty-unit">{isPlants ? "Pcs" : "Pallet"}</span>
        </div>
      </div>
    </div>
  );
};

export default QuantitySection;
